import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PasswordForgetLink } from './UserAccount/PasswordForget';
import { auth } from '../../firebase';
import * as routes from '../../constants/routes';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import {compose} from 'recompose'
import Typgraphy from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'


const SignInPage = ({ history }) =>
  <div style={{textAlign: 'center'}}>
    <Paper style={{backgroundColor: 'white', marginLeft: 'auto', marginRight: 'auto', maxWidth: '400px', padding: '16px', borderRadius: '8px'}} >
      <Typgraphy color='primary' variant='headline' children='Anmelden' gutterBottom />
      <SignInForm history={history} />
      <PasswordForgetLink />
    </Paper>
  </div>

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class SignInForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }



  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.LANDING);
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });
    event.preventDefault();
  }

  _renderErrorMessage = (error) => {
    const { code } = error
    switch (code) {
      case 'auth/too-many-requests':
        return'Sie haben zu oft das falsche Passwort eingegeben. Ihr Konto wurde gesperrt, versuchen Sie es in ein paar Minuten wieder.'
      case 'auth/wrong-password':
        return 'Sie haben ein falsches Passwort eingegeben. Bitte versuchen Sie es erneut.'
      case 'auth/user-not-found':
        return 'Zu dieser Email Adresse existiert kein Benutzerkonto. Überprüfen Sie ihre E-Mail Adresse.'
      case 'auth/invalid-email' :
        return 'E-Mail Adresse hat ein ungültiges Format. Bitte überprüfen Sie ihre E-Mail Adresse'
      default:
        return 'Es ist ein Fehler aufgetreten, bitte wenden Sie sich an die Geschäftsstelle'
     }
  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;

  const isInvalid = password.length<4 || email.indexOf('@')<2
    return (   
        <form onSubmit={this.onSubmit}>
          <Input
            value={email}
            onChange={event => this.setState(byPropKey('email', event.target.value))}
            type="text"
            placeholder="Email Adresse"
          />
          <br />
          <Input
            style={{marginTop: '1em'}}
            value={password}
            onChange={event => this.setState(byPropKey('password', event.target.value))}
            type="password"
            placeholder="Passwort"
          />
          <br />
    
          <Button style={{marginTop: '1em'}} variant="contained" color="primary" disabled={isInvalid} type="submit">
            Anmelden
          </Button>

          { error && <div style={{marginTop: '8px', color: 'red'}}>{this._renderErrorMessage(error)}</div>}
        </form>
    );
  }
}

export default compose(withRouter, withStyles(styles))(SignInPage);

export {
  SignInForm,
};


// WEBPACK FOOTER //
// ./src/Components/UserAuth/SignIn.js